import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Country } from '../../../../../shared/address/Country';
import { State } from '../../../../../shared/address/State';

@Component({
  selector: 'app-address-step',
  templateUrl: './address-step.component.html',
  styleUrls: ['./address-step.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule, 
    MatIcon,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule
  ]
})
export class AddressStepComponent {

  @Input('addressForm') form!: FormGroup;
  @Input('states') states!: State[];
  @Input('countries') countries!: Country[];

  panelOpen: boolean = false;

}